import React, { useEffect, useState } from "react";
import Layout from "../../../../components/layouts/Layout";
import UserDetailHeader from "../../../../components/user-detail/UserDetailHeader";
import DataTable from "react-data-table-component";
// import "react-toastify/dist/ReactToastify.css";
import ProgressComponent from "../../../../components/general/ProgressComponent";
import { GET_HISTORIC_STAFF_MEMBERS_REPORT } from "../../../../env";
import Dropdown from 'react-bootstrap/Dropdown';
import * as XLSX from "xlsx";
// BlobProvider, Canvas, Circle, ClipPath, Defs, Document, Ellipse, Font, G, Image, Line, LinearGradient, Link, Note, PDFDownloadLink, PDFViewer, Page, Path, Polygon, Polyline, RadialGradient, Rect, Stop, StyleSheet, Svg, Text, TextInstance, Tspan, View, createRenderer, default, pdf, render, renderToBuffer, renderToFile, renderToStream, renderToString, usePDF, version
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Line } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
// import Dropdown from 'react-bootstrap/Dropdown';
// BlobProvider, Canvas, Circle, ClipPath, Defs, Document, Ellipse, Font, G, Image, Line, LinearGradient, Link, Note, PDFDownloadLink, PDFViewer, Page, Path, Polygon, Polyline, RadialGradient, Rect, Stop, StyleSheet, Svg, Text, TextInstance, Tspan, View, createRenderer, default, pdf, render, renderToBuffer, renderToFile, renderToStream, renderToString, usePDF, version
// import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Line } from '@react-pdf/renderer';
// import { PDFViewer } from '@react-pdf/renderer';
import {
  getRecords,
  isSuccess,
  filterColumns,
  filterRowsByProperty,
  displayEnumProperty,
  // toastErrorMessages,
  catchAsync,
  // toastSuccessMessages,
  ExportButton,
} from "../../../../helper/helper";
import moment from "moment";

function HistoricStaffReports() {

  const [filteredRows, setFilteredRows] = useState([]);
  console.log("🚀 ~ HistoricStaffReports ~ filteredRows:", filteredRows)
  const [isLoading, setIsLoading] = useState(true);

  const apiQuery = {
    sortproperty: "createdAt",
    sortorder: -1,
    offset: 0,
    query: {
      critarion: { active: true },
    },
  };

  const processFetchRecords = (method, data) => {
    if (data?.status !== isSuccess) {
      // toastErrorMessages(toast?.error, data?.message, "", 1000, 1000);
    } else if (method === "get" && data?.status === isSuccess) {

      const staffMembers = data?.data?.staffMembers
      const filteredRows = filterRowsByProperty(
        staffMembers,
        (row) => row?.user?.name
      );
      // setUserData(filteredRows);
      setFilteredRows(filteredRows);
      setIsLoading(false);
    }
  };

  const fetchAllRecords = catchAsync(async (req, res) => {
    const response = await getRecords(GET_HISTORIC_STAFF_MEMBERS_REPORT, apiQuery);
    console.log("🚀 ~ fetchAllRecords ~ response:", response)

    processFetchRecords("get", response);
  });

  useEffect(() => {
    fetchAllRecords();
  }, []);






  const columns = [
    {
      name: "#",
      selector: (row, index) => (
        <span >
          {index + 1}
        </span>
      ),
      width: "50px",
      center: true,
    },
    {
      name: "Name",
      selector: (row) => {
        return (
          <div
            className="usersNameInfo py-2"
          >
            <span className="userInfo">
              <span className="nameBlock">{`${row?.user?.name && row?.user?.name}`}{" "}{`${row?.lastName !== null && row?.lastName !== undefined ? row?.lastName : ""}`}</span>
              <small className="nameBlock"> Title:{row?.title}</small>
              <small className="nameBlock"> Email:<a
                href={`mailto:${row?.user?.email}`}
                className="blackColor"

              >
                {row?.user?.email}
              </a></small>

            </span>
          </div>
        );
      },
      width: "200px",
    },
    {
      name: "Address",
      selector: (row) => {
        return (
          <>
            <span className="text-capitalize">{row?.houseFlatNumber}&nbsp;{row?.addressLine1}</span>
            <span className="text-capitalize">{row?.town}&nbsp;{row?.city}&nbsp; {row?.postcode}</span>
          </>
        );
      },
      wrap: true,
      width: "300px",
    },
    {
      name: "Job Title",
      selector: (row) => {
        return (
          <>
            <span className="text-capitalize">{row?.jobTitle}</span>
          </>
        );
      },
      width: "150px",
      wrap: true,
      center: true
    },
    {
      name: "DOB",
      selector: (row) => {
        return (
          <span >
            {moment(row?.stafDob).format("DD-MM-YYYY")}
          </span>
        );
      },
      width: "150px",
      wrap: true,
      center: true
    },
    {
      name: "Archived Date",
      selector: (row) => {
        return (
          row?.archiveDate ? (
            <span >
              {moment(row?.archiveDate).format("DD-MM-YYYY")}
            </span>
          ) : ("-"))
      },
      width: "150px",
      wrap: true,
      center: true
    },

    {
      name: "Contact No.",
      selector: (row) => {
        return (
          <>
            <a
              href={`tel:${row?.user?.phoneNumber}`}
              className="blackColor"

            >
              Primary: {row?.user?.phoneNumber}
            </a>
            <br />
            <a
              href={`tel:${row?.secondaryContactNo}`}
              className="blackColor"

            >
              Secondary: {row?.secondaryContactNo}
            </a>
          </>
        );
      },
      width: "200px",
      wrap: true
    },
    {
      name: "NOK Details",
      selector: (row) => {
        return (
          <div className="py-3">
            Name: {row?.nokName}
            <br />
            <a
              href={`mailto:${row?.nokEmailAddress}`}
              className="blackColor"

            >
              Email: {row?.nokEmailAddress}
            </a>
            <br />

            <a
              href={`tel:${row?.nokPrimaryContact}`}
              className="blackColor"

            >
              Primary Contact: {row?.nokPrimaryContact}
            </a>
            <a
              href={`tel:${row?.nokSecondaryContact}`}
              className="blackColor"

            ><br />
              Secondary Contact: {row?.nokSecondaryContact}
            </a>
            <br />
            Address:<br />
            <span className="text-capitalize">{row?.nokHouseFlatNumber}&nbsp;{row?.nokAddressLine}</span>
            <span className="text-capitalize">{row?.nokTown}&nbsp;{row?.nokCity}&nbsp; {row?.nokPostCode}&nbsp; {row?.nokCountry}</span>
            <br />
          </div>
        );
      },
      width: "300px",
      wrap: true
    },
  ];

  const filteredColumns = filterColumns(columns, (column) => column !== null);


  // Export Data

  const styles = StyleSheet.create({
    pages: {
      padding: "10px",
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: "black",
      marginBottom: "5px",
      textAlign: "center",
      padding: "10px",
      backgroundColor: "#f0f0f0"
    },
    sectionSubTitle: {
      fontSize: "14px",
      fontWeight: "black",
      marginBottom: "5px",
      textAlign: "center",
      padding: "10px",
      backgroundColor: "#f0f0f0"
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    },
    tableHead: {
      flexDirection: "row",
      justifyContent: "space-between",
      backgroundColor: "#f0f0f0",
      padding: "10px 10px",
      marginBottom: "5px",
      fontSize: "10px",
      fontWeight: "bold",
      wordWrap: "break-word",
    },
    tabBody: {
      flexDirection: "row",
      justifyContent: "space-between",
      padding: "10px 10px",
      borderBottom: "1px solid #ccc",
      fontSize: "10px",
      wordWrap: "break-word",
    },
    wordwrap: {
      flexBasis: "50%",
      wordWrap: "break-word",
    },
  });

  const MyDocument = (start) => (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.pages}>
        <View>
          <Text style={styles.sectionTitle}>Historic Staff Reports</Text>
          <View style={styles.tableHead}>
            <Text style={{ width: "25%" }}>Name</Text>
            <Text style={{ width: "25%" }}>Address</Text>
            <Text style={{ width: "15%" }}>Role</Text>
            <Text style={{ width: "15%" }}>DOB</Text>
            <Text style={{ width: "20%" }}>Contact</Text>
          </View>
          {filteredRows.map((row, index) => (
            <View key={index} style={styles.tabBody}>
              <Text style={{ width: "25%" }}>
                {`${row?.user?.name && row?.user?.name}`}{" "}{`${row?.lastName !== null && row?.lastName !== undefined ? row?.lastName : ""}\n`}
                {`${row.title && 'Title: ' + row.title + `\n`}`}
                {`${row?.user?.email && 'Email: ' + row?.user?.email + `\n`}`}
              </Text>
              <Text style={{ width: "25%" }}>
                {row?.houseFlatNumber}{" "}{row?.addressLine1}{" "}
                {row?.town}{" "}{row?.city}{" "} {row?.postcode}
              </Text>
              <Text style={{ width: "15%" }}>{row?.user?.role}</Text>
              <Text style={{ width: "15%" }}>{moment(row.stafDob).format("DD/MM/YYYY")}</Text>
              <Text style={{ width: "20%" }}>
                {`${row?.user?.phoneNumber && 'Primary: ' + row?.user?.phoneNumber + `\n`}`}
                {`${row?.secondaryContactNo && 'Secondary: ' + row?.secondaryContactNo + `\n`}`}
              </Text>
            </View>
          ))}
        </View>
      </Page>
    </Document >
  );

  const ExportButton = ({ data, data2, patientName, removeMoreColumns }) => {
    const handleExport = () => {
      // Preprocess data to format dates before exporting
      const formattedData = data.map(
        ({
          ...item
        }) => {
          const stafEmail = `${item?.user?.email || ""} `
          removeMoreColumns.forEach((column) => {
            delete item[column];
          });

          const contractedHours = item?.contractedHours?.contractedHours;
          const enhancedRate = item?.contractedHours?.enhancedRate;
          const overNightSleepRate = item?.contractedHours?.overNightSleepRate;
          const overtimeRate = item?.contractedHours?.overtimeRate;
          const perHourRate = item?.contractedHours?.perHourRate;
          const stafDob = moment(item?.stafDob).format("DD/MM/YYYY") || "";
          const createdAt = moment(item?.createdAt).format("DD/MM/YYYY") || "";
          const staffStartDate = moment(item?.staffStartDate).format("DD/MM/YYYY") || "";


          return {
            ...item,
            contractedHours: contractedHours,
            enhancedRate: enhancedRate,
            overNightSleepRate: overNightSleepRate,
            overtimeRate: overtimeRate,
            perHourRate: perHourRate,
            staffDob: stafDob,
            createdAt: createdAt,
            staffStartDate: staffStartDate,
            staffEmail: stafEmail,
          };
        }
      );

      const formattedData2 = [{ "Historic Staff Reports": patientName }];

      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const fileName = patientName;

      // Convert dataWithTitles array to worksheet
      let ws = XLSX.utils.json_to_sheet(formattedData2);

      // Add second data set to existing worksheet
      const ws2 = XLSX.utils.json_to_sheet(formattedData, {
        header: Object.keys(formattedData[0]),
        skipHeader: true,
      });

      XLSX.utils.sheet_add_json(ws, formattedData, {
        header: Object.keys(formattedData[0]),
        skipHeader: false,
        origin: -1,
      });

      // Create workbook
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

      // Write workbook to array buffer
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

      // Convert array buffer to Blob
      const blob = new Blob([excelBuffer], { type: fileType });

      // Create download link and trigger download
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName + fileExtension;
      a.click();
    };

    return <span onClick={handleExport}>Export as xlsx</span>;
  };
  return (
    <>
      <Layout pageTitleText="Historic Staff Reports">
        <header className="headerContainerSearchAction">
          <div className="actionButtons">
            <div className="gap-1">
              <a className="btn btn-sm btn-primary" href="/reports">
                Back to Reports
              </a>
              <>
                {
                  filteredRows.length > 0 && (
                    <Dropdown>
                      <Dropdown.Toggle variant="outline-success" size="sm" id="dropdown-basic">
                        Export Data
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="exportDataList">
                        <>
                          {/* <span className="">
                                                        <PDFDownloadLink document={<MyDocument columns={columns} data={filteredColumns} />} fileName={"Historic Staff Reports"}>
                                                            {({ loading }) =>
                                                                loading ? '...' : 'Export as PDF'
                                                            }
                                                        </PDFDownloadLink>
                                                    </span> */}
                          <span className="">
                            <ExportButton data={filteredRows} patientName={"Historic Staff Reports"} removeMoreColumns={["_id", "user", "managerId", "stafDob", "active", "archiveDate", "createdAt", "updatedAt", "supervisorId", "supervisorId", "applicationForm", "offerLetter", "interviewForm", "cv", "preScreen", "rightToWork", "proofOfAddress", "photographicIdentification", "DBSCertificate", "references", "bankDetailsForm", "personalDetailsForm", "hourOptOutForm", "healthDeclaration", "equalOpportunities", "BYODSignedDeclaration", "proofOfNationalInsurance", "kin"]} />
                          </span>
                        </>

                      </Dropdown.Menu>
                    </Dropdown>
                  )
                }
              </>
            </div>
          </div>
        </header>

        {/* <PDFViewer style={{ width: "100%", height: "300px" }}>
          <MyDocument />
        </PDFViewer> */}
        <div className="mainContent noCursorPointer">
          <div className="dataTableWrapper staffRecordsGroupsTable">
            <DataTable
              className="maxWidthTable"
              columns={filteredColumns}
              data={filteredRows}
              fixedHeader
              fixedHeaderScrollHeight="520px"
              // highlightOnHover
              responsive={true}
              subHeaderWrapperProps={{ style: { padding: 0, margin: 0 } }}
              progressPending={isLoading}
              progressComponent={<ProgressComponent />}
            />
          </div>
        </div>
      </Layout>
    </>
  );
}

export default HistoricStaffReports;
